// @subframe/sync-disable

"use client";
/*
 * Documentation:
 * Dc_Text_Link_Excursion_Unsynced — https://app.subframe.com/4f62853ee923/library?component=Dc_Text_Link_Excursion_Unsynced_0e22c379-d052-4e36-8d9a-479bc2ecb41c
 */

import React from "react";
import { FeatherLink2 } from "@subframe/core";
import * as SubframeUtils from "../utils";

interface Dc_Text_Link_Excursion_UnsyncedRootProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  text?: React.ReactNode;
  className?: string;
}

const Dc_Text_Link_Excursion_UnsyncedRoot = React.forwardRef<
  HTMLSpanElement,
  Dc_Text_Link_Excursion_UnsyncedRootProps
>(function Dc_Text_Link_Excursion_UnsyncedRoot(
  { text, className, ...otherProps }: Dc_Text_Link_Excursion_UnsyncedRootProps,
  ref
) {
  return (
    <span
      className={SubframeUtils.twClassNames(
        "group/0e22c379 inline-flex cursor-pointer items-center gap-1 bg-neutral-50 px-1.5 hover:border-b hover:border-solid hover:border-neutral-border hover:bg-neutral-100 hover:mb-[-1px]",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {text ? (
        <span className="text-body font-body text-default-font inline">
          {text}
        </span>
      ) : null}
      <span className="flex items-center gap-1 pl-1 leading-[1em] align-middle">
        <FeatherLink2 className="text-body font-body text-default-font" />
      </span>
    </span>
  );
});

export const Dc_Text_Link_Excursion_Unsynced =
  Dc_Text_Link_Excursion_UnsyncedRoot;
